import React from 'react';
import PropTypes from 'prop-types';
import CustomPortal from '../../commonComponents/CustomPortal';
import { InlineLinkButton } from '../../commonComponents/InlineLinkButton';
import { COLORS, promotionPropType } from './constants';

const labelStyle = {
  display: 'block',
  fontWeight: 700,
  fontSize: 16,
  marginBottom: 8,
  color: COLORS.text,
};

export const PayoutSelectStep = ({
  activePromotions,
  selectedId,
  setSelectedId,
  file,
  fileInputRef,
  onFileChange,
  onUpload,
  isReading,
  onClose,
}) => (
  <CustomPortal
    title="Upload Payout List"
    cancelText="Close"
    submitText="Upload"
    cancelPressed={onClose}
    submitPressed={onUpload}
    rightButtonDisabled={isReading}
  >
    <div style={{ width: '100%', maxWidth: 360, margin: '0 auto' }}>
      <label htmlFor="payout-promotion" style={labelStyle}>
        Select promotion
        <select
          id="payout-promotion"
          aria-label="Select promotion"
          className="custom-select custom-select-lg"
          style={{ marginTop: 8 }}
          value={selectedId}
          onChange={(event) => setSelectedId(event.target.value)}
        >
          <option value="" disabled>
            Select a promotion
          </option>
          {activePromotions.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>
      </label>

      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 24 }}>
        <InlineLinkButton onClicked={() => fileInputRef.current?.click()}>
          Choose file
        </InlineLinkButton>
        <span style={{ fontSize: 14, color: COLORS.text }}>
          {file ? file.name : '.CSV Files Only'}
        </span>
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,text/csv"
          aria-label="Payout CSV file"
          style={{ display: 'none' }}
          onChange={onFileChange}
        />
      </div>
    </div>
  </CustomPortal>
);

PayoutSelectStep.propTypes = {
  activePromotions: PropTypes.arrayOf(promotionPropType).isRequired,
  selectedId: PropTypes.string.isRequired,
  setSelectedId: PropTypes.func.isRequired,
  file: PropTypes.instanceOf(File),
  fileInputRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  onFileChange: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  isReading: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

PayoutSelectStep.defaultProps = { file: null };
